/**
 * Vocabulary and spelling words for UK Key Stage 2 (Years 3–5) with hints to identify the word.
 */
export const FLASHCARD_WORDS_WITH_HINTS = [
    { word: "ANSWER", hint: "What you write or say when someone asks you a question." },
    { word: "BELIEVE", hint: "To think that something is true or real." },
    { word: "CALENDAR", hint: "A chart showing the days, weeks and months of the year." },
    { word: "DECIDE", hint: "To make a choice after thinking about it." },
    { word: "ENOUGH", hint: "As much as you need; no more, no less." },
    { word: "FAVOURITE", hint: "The one you like best (UK spelling)." },
    { word: "GUARD", hint: "Someone who watches over a place or person to keep them safe." },
    { word: "HEIGHT", hint: "How tall something is from bottom to top." },
    { word: "IMAGINE", hint: "To picture something in your mind." },
    { word: "KNOWLEDGE", hint: "Facts and information that you have learned." },
    { word: "LENGTH", hint: "How long something is from one end to the other." },
    { word: "MINUTE", hint: "A unit of time; 60 seconds." },
    { word: "NATURAL", hint: "Found in nature; not made by people." },
    { word: "OCCASION", hint: "A special event or time." },
    { word: "PARTICULAR", hint: "One specific thing, not just any." },
    { word: "QUESTION", hint: "A sentence that asks something and ends with a ?" },
    { word: "REIGN", hint: "The time when a king or queen rules." },
    { word: "SEPARATE", hint: "To move or keep things apart from each other." },
    { word: "THEREFORE", hint: "A word that means 'for that reason' or 'so'." },
    { word: "VARIOUS", hint: "Many different kinds." },
    { word: "WEIGHT", hint: "How heavy something is." },
    { word: "ALTHOUGH", hint: "A word that means 'even though' or 'but'." },
    { word: "DIFFERENT", hint: "Not the same as something else." },
    { word: "EXERCISE", hint: "Physical activity to keep your body healthy." },
    {
        word: "GRAMMAR",
        hint: "The rules for how we put words together in sentences.",
        hints: [
            "It is about how words are arranged to make clear sentences.",
            "It includes rules for verbs, tenses, punctuation and word order.",
            "Good ______ helps your writing make sense to the reader.",
        ],
    },
    { word: "IMPORTANT", hint: "Something that matters a lot." },
    { word: "INTEREST", hint: "A feeling of wanting to know or learn about something." },
    { word: "LIBRARY", hint: "A place where you can borrow books to read." },
    { word: "MATERIAL", hint: "What something is made from, e.g. wood, plastic." },
    { word: "MEDICINE", hint: "Something you take when you are ill to help you get better." },
    { word: "NAUGHTY", hint: "Behaving badly on purpose." },
    {
        word: "OPPOSITE",
        hint: "Completely different; the reverse (e.g. hot is the ___ of cold).",
        hints: [
            "It describes things that are completely different from each other.",
            "Hot and cold are an example pair of this.",
            "The word starts with the letter \"O\".",
        ],
    },
    { word: "POSSESS", hint: "To own or have something." },
    { word: "RECENT", hint: "Something that happened not long ago." },
    { word: "SENTENCE", hint: "A group of words that express a complete thought." },
    { word: "THROUGH", hint: "From one side to the other; from start to end." },
    { word: "WOMAN", hint: "An adult female person." },
    { word: "WOMEN", hint: "More than one adult female (plural of woman)." },
    { word: "ACTUAL", hint: "Real; the real thing, not a guess." },
    { word: "ADDRESS", hint: "The place where someone lives; or to speak to someone." },
    { word: "BREATH", hint: "The air you take in and let out (noun)." },
    { word: "BREATHE", hint: "To take air in and out of your lungs (verb)." },
    { word: "BUILD", hint: "To make something by putting parts together." },
    { word: "BUSY", hint: "Having a lot to do; not free." },
    { word: "CENTRE", hint: "The middle of something (UK spelling)." },
    { word: "CENTURY", hint: "A period of 100 years." },
    { word: "CERTAIN", hint: "Sure; having no doubt." },
    { word: "CIRCLE", hint: "A round shape like a ring or a wheel." },
    { word: "COMPLETE", hint: "Having all parts; finished." },
    { word: "CONSIDER", hint: "To think carefully about something." },
    { word: "CONTINUE", hint: "To keep going without stopping." },
    { word: "DESCRIBE", hint: "To say what something is like in words." },
    { word: "EARLY", hint: "Before the usual or expected time." },
    { word: "EARTH", hint: "The planet we live on." },
    { word: "EIGHT", hint: "The number 8." },
    { word: "EIGHTH", hint: "Coming after seventh; position 8." },
    { word: "EXPERIENCE", hint: "Something that has happened to you; knowledge from doing things." },
    { word: "EXPERIMENT", hint: "A test done to find out if something is true." },
    { word: "EXTREME", hint: "Very great; at the furthest limit." },
    { word: "FAMOUS", hint: "Known by many people." },
    { word: "FORWARD", hint: "Towards the front; ahead." },
    { word: "FRUIT", hint: "Food from plants that often has seeds, e.g. apples, bananas." },
    { word: "GROUP", hint: "A number of people or things together." },
    { word: "GUIDE", hint: "Someone or something that shows you the way." },
    { word: "HEARD", hint: "Past tense of hear; you listened and understood." },
    { word: "HEART", hint: "The organ in your chest that pumps blood." },
    { word: "HISTORY", hint: "Events that happened in the past." },
    { word: "INCREASE", hint: "To become larger or more." },
    { word: "ISLAND", hint: "Land with water all around it." },
    { word: "LEARN", hint: "To get knowledge or skill by studying or practising." },
    { word: "MENTION", hint: "To say something briefly." },
    { word: "OFTEN", hint: "Many times; frequently." },
    { word: "PERHAPS", hint: "Maybe; possibly." },
    { word: "POPULAR", hint: "Liked by many people." },
    { word: "POSITION", hint: "Where something is placed." },
    { word: "POSSIBLE", hint: "Something that can happen or be done." },
    { word: "PRESSURE", hint: "A force pushing on something; or feeling stressed." },
    { word: "PROBABLY", hint: "Almost certainly; very likely." },
    { word: "PROMISE", hint: "To say you will definitely do something." },
    { word: "PURPOSE", hint: "The reason why something exists or is done." },
    { word: "QUARTER", hint: "One of four equal parts; ¼." },
    { word: "REMEMBER", hint: "To keep something in your mind; not forget." },
    { word: "SPECIAL", hint: "Better or more important than usual." },
    { word: "STRAIGHT", hint: "Not curved or bent; in a direct line." },
    { word: "STRANGE", hint: "Unusual or odd." },
    { word: "STRENGTH", hint: "How strong something or someone is." },
    { word: "SUPPOSE", hint: "To think something is likely; to guess." },
    { word: "SURPRISE", hint: "Something unexpected that happens." },
    { word: "THOUGH", hint: "Although; even if." },
    { word: "THOUGHT", hint: "An idea in your mind; past tense of think." },
    { word: "NOTICE", hint: "To see or become aware of something." },
    { word: "ORDINARY", hint: "Normal; not special or different." },
    { word: "PECULIAR", hint: "Strange or unusual." },
    { word: "REGULAR", hint: "Happening often in the same way; normal." },
    { word: "POTATOES", hint: "Vegetables that grow underground; plural of potato." },
    { word: "ACCIDENT", hint: "Something bad that happens by chance, not on purpose." },
    { word: "ACTUALLY", hint: "In fact; really." },
    { word: "APPEAR", hint: "To become visible; to seem." },
    { word: "ARRIVE", hint: "To reach a place you were going to." },
    { word: "BICYCLE", hint: "A vehicle with two wheels that you pedal." },
    { word: "CAUGHT", hint: "Past tense of catch; you got hold of something." },
    { word: "DIFFICULT", hint: "Hard to do or understand." },
    { word: "DISAPPEAR", hint: "To go out of sight; to vanish." },
    {
        word: "FRACTION",
        hint: "Part of a whole, e.g. ½ or ¼ (maths).",
        hints: [
            "It shows how many parts of a whole you have.",
            "It is written with a top and bottom number separated by a line.",
            "Examples include 1/2, 3/4 and 7/10.",
        ],
    },
    {
        word: "DECIMAL",
        hint: "A number with a point, e.g. 3.14 (maths).",
        hints: [
            "It uses a dot to separate whole numbers from parts of a whole.",
            "0.5 is an example of this type of number.",
            "Numbers like 0.25 and 3.14 are written in this form.",
        ],
    },
    {
        word: "MULTIPLY",
        hint: "To add a number to itself many times (×).",
        hints: [
            "It is the operation that repeats addition.",
            "The answer is called the product.",
            "Times tables are an example of this operation.",
        ],
    },
    {
        word: "DIVIDE",
        hint: "To split into equal parts (÷).",
        hints: [
            "It means sharing a number into equal groups.",
            "The answer can have a quotient and a remainder.",
            "The opposite operation is multiply.",
        ],
    },
    { word: "ADDITION", hint: "Putting numbers together; the + operation." },
    { word: "SUBTRACT", hint: "To take away one number from another (−)." },
    { word: "MEASURE", hint: "To find the size, length or amount of something." },
    {
        word: "SYMMETRY",
        hint: "When one half of a shape is a mirror image of the other.",
        // 3-click hint system: Easy → Medium → Hard
        hints: [
            "It means both sides are the same (balanced).",
            "The dividing line is called a line of symmetry.",
            "It ends with “-try”.",
        ],
    },
    {
        word: "PARALLEL",
        hint: "Lines that stay the same distance apart and never meet.",
        hints: [
            "Two lines with this property never meet, even if extended.",
            "They stay the same distance apart all the way along.",
            "Railway tracks are a good real‑life example.",
        ],
    },
    {
        word: "PERIMETER",
        hint: "The distance around the outside of a shape.",
        hints: [
            "You find it by adding the lengths of all the sides.",
            "It is measured in units like centimetres or metres.",
            "It describes how far it is to walk all the way around a shape.",
        ],
    },
    {
        word: "TRIANGLE",
        hint: "A shape with three sides and three angles.",
        hints: [
            "Its three angles always add up to 180 degrees.",
            "Types include equilateral, isosceles and scalene.",
            "It is the simplest polygon that can have an area.",
        ],
    },
    { word: "POLYGON", hint: "A flat shape with straight sides, e.g. triangle, hexagon." },
    {
        word: "PATTERN",
        hint: "Something that repeats in a regular way.",
        hints: [
            "It can be made from repeating colours, shapes or numbers.",
            "You can use it to predict what comes next.",
            "Wallpaper and number puzzles often use this idea.",
        ],
    },
    {
        word: "SEQUENCE",
        hint: "An order of numbers or things that follow a rule.",
        hints: [
            "Each term follows a rule from the term before.",
            "The 2, 4, 6, 8… times‑table is an example.",
            "You can ask what the next or missing term in it is.",
        ],
    },
    { word: "ESTIMATE", hint: "A rough guess of a number or amount." },
    { word: "VERTICAL", hint: "Going straight up and down, like a standing line." },
    { word: "HORIZONTAL", hint: "Going straight across, like the horizon." },
    { word: "CAPACITY", hint: "How much a container can hold (e.g. litres)." },
    { word: "TEMPERATURE", hint: "How hot or cold something is (measured in °C)." },
    { word: "DISTANCE", hint: "How far it is from one place to another." },
    { word: "VOLUME", hint: "The amount of space something takes up (maths/science)." },
    { word: "DIAMETER", hint: "A line across a circle through its centre." },
    { word: "RADIUS", hint: "The distance from the centre of a circle to its edge." },
    { word: "ANGLE", hint: "The space between two lines that meet (measured in degrees)." },
    { word: "VERTEX", hint: "The corner point where two edges of a shape meet." },
    { word: "SQUARE", hint: "A shape with four equal sides and four right angles." },
    { word: "RECTANGLE", hint: "A shape with four sides and four right angles; opposite sides equal." },
    { word: "PENTAGON", hint: "A shape with five sides." },
    { word: "HEXAGON", hint: "A shape with six sides." },
    { word: "SPHERE", hint: "A round 3D shape like a ball." },
    { word: "CYLINDER", hint: "A 3D shape like a tube or tin can." },
    { word: "FACTOR", hint: "A number that divides exactly into another (maths)." },
    { word: "MULTIPLE", hint: "A number that is the product of a given number (e.g. 6 is a ___ of 2)." },
    { word: "PRIME", hint: "A number that can only be divided by 1 and itself (e.g. 2, 5, 7)." },
    { word: "SUM", hint: "The answer when you add numbers together." },
    { word: "PRODUCT", hint: "The answer when you multiply numbers." },
    { word: "QUOTIENT", hint: "The answer when you divide one number by another." },
    { word: "REMAINDER", hint: "What is left over after division (e.g. 7 ÷ 2 has ___ 1)." },
    {
        word: "EQUATION",
        hint: "A maths sentence with an equals sign, e.g. 3 + 2 = 5.",
        hints: [
            "Both sides of it have the same value.",
            "You often solve it to find a missing number.",
            "It always includes an equals sign (=).",
        ],
    },
    {
        word: "PERCENT",
        hint: "Out of 100; shown with the % symbol.",
        hints: [
            "It literally means \"per hundred\".",
            "50% is the same as one half.",
            "The symbol used is the % sign.",
        ],
    },
    {
        word: "RATIO",
        hint: "A way to compare two amounts (e.g. 2 : 3).",
        hints: [
            "It compares two or more quantities using a colon.",
            "You might use it to share something in parts, like 2 : 3.",
            "You can simplify it in a similar way to a fraction.",
        ],
    },
    { word: "NUMERATOR", hint: "The top number in a fraction." },
    { word: "DENOMINATOR", hint: "The bottom number in a fraction." },
    { word: "EQUIVALENT", hint: "Equal in value (e.g. ½ and 2/4 are ___ fractions)." },
    { word: "DIAGRAM", hint: "A simple drawing that explains something." },
    { word: "APPROXIMATE", hint: "Close to the exact value; roughly." },
    { word: "CIRCUMFERENCE", hint: "The distance around the edge of a circle." },
    { word: "PYRAMID", hint: "A 3D shape with a polygon base and triangular sides meeting at a point." },
    { word: "PRISM", hint: "A 3D shape with two identical ends and flat sides (e.g. cuboid)." },
    { word: "COMPOSITE", hint: "A number with more than two factors (not prime)." },
    { word: "QUADRILATERAL", hint: "Any flat shape with four straight sides." },
    { word: "OCTAGON", hint: "A shape with eight sides." },
];

// Subject keys matching STUDENT_GAME_SUBJECTS. A word can belong to more than one subject.
const MATHS_WORDS = new Set([
    "FRACTION", "DECIMAL", "MULTIPLY", "DIVIDE", "ADDITION", "SUBTRACT", "MEASURE", "PARALLEL",
    "PERIMETER", "ESTIMATE", "VERTICAL", "HORIZONTAL", "CAPACITY", "TEMPERATURE", "DISTANCE", "VOLUME",
    "DIAMETER", "RADIUS", "ANGLE", "VERTEX", "FACTOR", "MULTIPLE", "PRIME", "SUM", "PRODUCT", "QUOTIENT",
    "REMAINDER", "EQUATION", "PERCENT", "RATIO", "NUMERATOR", "DENOMINATOR", "EQUIVALENT", "DIAGRAM",
    "APPROXIMATE", "CIRCUMFERENCE", "PRISM", "COMPOSITE", "QUARTER", "EIGHT", "EIGHTH", "LENGTH", "WEIGHT", "HEIGHT", "MINUTE",
]);
const NVR_WORDS = new Set([
    "SYMMETRY", "PATTERN", "SEQUENCE", "TRIANGLE", "SQUARE", "RECTANGLE", "POLYGON", "CIRCLE",
    "PENTAGON", "HEXAGON", "SPHERE", "CYLINDER", "PYRAMID", "QUADRILATERAL", "OCTAGON",
]);
const VR_WORDS = new Set([
    "OPPOSITE", "DIFFERENT", "QUESTION", "ANSWER", "THEREFORE", "CONSIDER", "PECULIAR", "ORDINARY",
]);

function getSubjectsForWord(word) {
    const subjects = [];
    if (MATHS_WORDS.has(word)) subjects.push("maths");
    if (NVR_WORDS.has(word)) {
        subjects.push("maths");
        subjects.push("non-verbal-reasoning");
    }
    if (VR_WORDS.has(word)) subjects.push("verbal-reasoning");
    if (subjects.length === 0) subjects.push("english");
    return subjects;
}

const wordsWithSubject = FLASHCARD_WORDS_WITH_HINTS.map((item) => ({
    ...item,
    subjects: item.subjects ?? getSubjectsForWord(item.word),
}));

const validWords = wordsWithSubject.filter(
    (item) =>
        item.word.length >= 4 &&
        item.word.length <= 10 &&
        /^[A-Z]+$/.test(item.word)
);

export function getRandomWordWithHint(subjectKey) {
    const pool = subjectKey
        ? validWords.filter((item) => item.subjects && item.subjects.includes(subjectKey))
        : validWords;
    if (pool.length === 0) return validWords[Math.floor(Math.random() * validWords.length)];
    return pool[Math.floor(Math.random() * pool.length)];
}

/** Backwards compatibility: returns just the word string. */
export function getRandomWord() {
    const item = getRandomWordWithHint();
    return item ? item.word : "WORD";
}
